import React from 'react';
import { Wrapper, WrapperProps } from 'dot-design-system';

interface Props extends WrapperProps {}

function Bolt(props: Props) {
	return (
		<Wrapper
			component={'svg'}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 480.096 480.096'
			{...props}
		>
			<path d='M370.032 178.808h-107.08L292.744 0l-182.68 258.808h108.704l-29.504 221.288 180.768-301.288zm-229.088 64l124.512-176.4-21.4 128.4h97.72L215.352 405.52l21.688-162.712h-96.096z' />
		</Wrapper>
	);
}

export default Bolt;
